import { render, staticRenderFns } from "./FreeBlocksSettings.vue?vue&type=template&id=764c385a&scoped=true"
import script from "./FreeBlocksSettings.vue?vue&type=script&lang=ts"
export * from "./FreeBlocksSettings.vue?vue&type=script&lang=ts"
import style0 from "./FreeBlocksSettings.vue?vue&type=style&index=0&id=764c385a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764c385a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('764c385a')) {
      api.createRecord('764c385a', component.options)
    } else {
      api.reload('764c385a', component.options)
    }
    module.hot.accept("./FreeBlocksSettings.vue?vue&type=template&id=764c385a&scoped=true", function () {
      api.rerender('764c385a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/FreeBlocksSettings.vue"
export default component.exports